import css from './test.module.scss';

import cx from 'classnames';
import { Fragment, memo } from 'react';

import { getDateTimeLabel } from 'core/helpers/dates';
import { Icon } from 'core/ui/icons';

import { QuestionImage } from './QuestionImage';
import { TAuxQuestion } from './types';

type Props = {
  question: TAuxQuestion;
  isDue: boolean;
  selection: number | null;
};

function QuestionHeader({ question, selection, isDue }: Props) {
  return (
    <div className={css.header}>
      <div className={css.question}>
        <div
          title={
            isDue
              ? `It's time to repeat this question. Attempts: ${question.tryouts}.` +
                (question.lastProbeAt
                  ? ` Last try: ${getDateTimeLabel(question.lastProbeAt)}`
                  : ``)
              : `Repeat this question after ${getDateTimeLabel(
                  question.nextProbeAt
                )}.`
          }
          className={cx(css.dueIconWrapper, !isDue && css.inactive)}
        >
          <Icon icon="Time" className={css.dueIcon} />
        </div>
        {question.question}
        {question.reseted > 0 && (
          <span
            className={css.wrongAttemptsNumber}
            title={`This question was answered wrong ${question.reseted} times`}
          >
            {question.reseted >= 5 ? `***` : question.reseted > 2 ? '**' : '*'}
          </span>
        )}
        {question.hint && (
          <Fragment key="hint">
            {' '}
            <span className={css.hint} data-hidden={selection == null}>
              (&zwnj;{question.hint}&zwnj;)
            </span>
          </Fragment>
        )}
      </div>
      {question.resourceUid && (
        <QuestionImage resourceUid={question.resourceUid} />
      )}
    </div>
  );
}

export default memo(QuestionHeader);
